import React from "react";

interface FullScreenLoaderProps {
  message?: string;
}

export function FullScreenLoader({ message = "Cargando..." }: FullScreenLoaderProps) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
      }}
    >
      <div className="spinner" />
      <div style={{ fontWeight: 600, color: "#1d4ed8" }}>{message}</div>
    </div>
  );
}
